import { Theme } from "apps/website/maps/Theme.map";
import {
  IStoryBlokComponent,
  IStoryBlokCta,
} from "apps/website/components/page/api.types";
import { getStoryBlokCtas } from "apps/website/utils/storyblok/links";
import SectionColumnTable from
  "apps/website/components/section/SectionTable/SectionColumnTable/SectionColumnTable";
import { getStoryBlokTableValue } from "apps/website/utils/storyblok/table";
import {
  IColumnTableRow,
} from "apps/website/components/feature/Table/ColumnTable/ColumnTable";
import { renderStoryBlokRichText } from "apps/website/utils/storyblok/text";

export interface IStoryBlokTableHead {
  _uid: string;
  value: string;
}

export interface IStoryBlokTableBodyValue {
  _uid: string;
  value: string;
}

export interface IStoryBlokTableBody {
  body: IStoryBlokTableBodyValue[]
}

export interface IStoryBlokTable {
  thead: IStoryBlokTableHead[];
  tbody: IStoryBlokTableBody[];
}

export interface IStoryBlokTableFeature {
  title: string;
  type: "column_table" | "row_table" | "column_row_table";
  table: IStoryBlokTable;
}

export interface IStoryBlokColumnTable {
  title: string;
  table: IStoryBlokTable;
  cta?: IStoryBlokCta[];
  theme?: Theme;
  source?: string;
}

export const StoryBlokColumnTable = ({ blok }: IStoryBlokComponent<IStoryBlokColumnTable>) => (
  <SectionColumnTable
    title={blok.title}
    table={{
      titles: blok.table.thead.map((title) => ({
        id: title._uid,
        name: title.value,
      })),
      rows: blok.table.tbody.map((row) => ({
        values: row.body.map((cell) => (
          getStoryBlokTableValue(cell.value)
        )),
      })) as IColumnTableRow[],
    }}
    cta={getStoryBlokCtas(blok.cta ?? [])}
    theme={blok.theme}
    source={blok.source ? renderStoryBlokRichText(blok.source, { unwrapResolvers: true, links: { display: "default" } }) : undefined}
  />
);
